export default "__VITE_ASSET__CKRT6Slj__"